// extracted by mini-css-extract-plugin
export default {"appWrapper":"styles_appWrapper__BHxbg","pages":"styles_pages__z1Eab","hidden":"styles_hidden__Y8PkQ"};